(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sutton-trustpilot-reviews"] && !Shopify.designMode) return;
  try {
    

/* Native scrolling only. There is no automatic rotation or third-party slider. */
(() => {
  const tag = 'sutton-trustpilot-slider';
  if (!window.customElements || customElements.get(tag)) return;

  class SuttonTrustpilotSlider extends HTMLElement {
    connectedCallback() {
      this.startFrame = requestAnimationFrame(() => this.init());
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.startFrame);
      cancelAnimationFrame(this.scrollFrame);
      clearTimeout(this.announceTimer);
      this.abort?.abort();
      this.resizeObserver?.disconnect();
      this.mutationObserver?.disconnect();
      this.track?.removeAttribute('data-dragging');
      this.abort = null;
      this.drag = null;
      this.removeAttribute('data-ready');
    }
    init() {
      if (this.abort || !this.isConnected) return;
      this.track = this.querySelector('[data-track]');
      if (!this.track) return;
      this.previous = this.querySelector('[data-previous]');
      this.next = this.querySelector('[data-next]');
      this.nav = this.querySelector('[data-nav]');
      this.status = this.querySelector('[data-status]');
      this.motion = window.matchMedia('(prefers-reduced-motion: reduce)');
      this.abort = new AbortController();
      const signal = this.abort.signal;
      const on = (node, event, callback, options = {}) => {
        if (node) node.addEventListener(event, callback, { ...options, signal });
      };
      on(this.previous, 'click', () => this.move(-1));
      on(this.next, 'click', () => this.move(1));
      on(this.track, 'scroll', () => {
        cancelAnimationFrame(this.scrollFrame);
        this.scrollFrame = requestAnimationFrame(() => this.update());
        clearTimeout(this.announceTimer);
        this.announceTimer = setTimeout(() => this.announce(), 180);
      }, { passive: true });
      on(this.track, 'keydown', event => {
        if (event.target !== this.track || event.altKey || event.ctrlKey || event.metaKey || event.shiftKey) return;
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          const direction = event.key === 'ArrowRight' ? 1 : -1;
          this.move(this.rtl ? -direction : direction);
        } else if (event.key === 'Home' || event.key === 'End') {
          event.preventDefault();
          this.go(event.key === 'Home' ? 0 : this.positions.length - 1);
        }
      });
      // Touch swiping and trackpads remain entirely native. Only mouse dragging
      // is enhanced, and links/buttons keep their normal click behaviour.
      on(this.track, 'pointerdown', event => {
        if (event.pointerType !== 'mouse' || event.button !== 0 || window.Shopify?.designMode) return;
        if (event.target.closest('a, button, input, textarea, select')) return;
        this.drag = { id: event.pointerId, x: event.clientX, y: event.clientY, left: this.track.scrollLeft, active: false };
      }, { passive: true });
      on(window, 'pointermove', event => {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        const dx = event.clientX - drag.x;
        const dy = event.clientY - drag.y;
        if (!drag.active) {
          if (Math.abs(dy) > Math.abs(dx) && Math.abs(dy) > 8) { this.drag = null; return; }
          if (Math.abs(dx) < 8) return;
          drag.active = true;
          this.track.setAttribute('data-dragging', '');
          this.track.setPointerCapture(event.pointerId);
          window.getSelection()?.removeAllRanges();
        }
        event.preventDefault();
        this.track.scrollLeft = drag.left - dx;
      }, { passive: false });
      const finish = event => {
        const drag = this.drag;
        if (!drag || event.pointerId !== drag.id) return;
        this.drag = null;
        if (drag.active) {
          if (this.track.hasPointerCapture(drag.id)) this.track.releasePointerCapture(drag.id);
          const position = this.nearest();
          this.track.removeAttribute('data-dragging');
          this.go(position);
        }
      };
      on(window, 'pointerup', finish);
      on(window, 'pointercancel', finish);
      on(this.track, 'lostpointercapture', finish);
      on(window, 'blur', () => { this.drag = null; this.track.removeAttribute('data-dragging'); });
      // A review selected in the Shopify sidebar is brought into this track's view.
      on(this, 'shopify:block:select', event => {
        const item = this.items.find(node => node.dataset.reviewId === String(event.detail?.blockId));
        if (item) this.scrollToPosition(this.itemPosition(item), true);
      });
      if ('ResizeObserver' in window) {
        this.resizeObserver = new ResizeObserver(() => this.measure());
        this.resizeObserver.observe(this.track);
      } else {
        on(window, 'resize', () => this.measure());
      }
      if ('MutationObserver' in window) {
        this.mutationObserver = new MutationObserver(() => this.measure());
        this.mutationObserver.observe(this.track, { childList: true });
      }
      this.setAttribute('data-ready', '');
      this.measure();
    }
    offset() {
      return Math.max(0, Math.min(this.max || 0, this.rtl ? -this.track.scrollLeft : this.track.scrollLeft));
    }
    itemPosition(item) {
      const viewport = this.track.getBoundingClientRect();
      const rect = item.getBoundingClientRect();
      const delta = this.rtl ? viewport.right - rect.right : rect.left - viewport.left;
      return Math.max(0, Math.min(this.max, this.offset() + delta));
    }
    measure() {
      if (!this.abort || !this.isConnected) return;
      this.items = Array.from(this.track.children).filter(node => node.matches('[data-review-id]') && !node.hidden);
      this.rtl = getComputedStyle(this.track).direction === 'rtl';
      this.max = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
      const positions = this.items.map(item => this.itemPosition(item));
      this.positions = positions.filter((position, index) => index === 0 || Math.abs(position - positions[index - 1]) > 2);
      if (!this.positions.length) this.positions = [0];
      if (this.nav) this.nav.hidden = this.max < 3 || this.items.length < 2;
      this.update();
    }
    nearest() {
      const offset = this.offset();
      return this.positions.reduce((best, position, index) =>
        Math.abs(position - offset) < Math.abs(this.positions[best] - offset) ? index : best, 0);
    }
    update() {
      const offset = this.offset();
      if (this.previous) this.previous.disabled = offset < 3;
      if (this.next) this.next.disabled = this.max - offset < 3;
    }
    scrollToPosition(position, instant = false) {
      const value = Math.max(0, Math.min(this.max, position));
      this.track.scrollTo({
        left: this.rtl ? -value : value,
        behavior: instant || this.motion.matches || this.dataset.motion === 'false' ? 'auto' : 'smooth'
      });
    }
    go(index) {
      if (!this.positions?.length) return;
      const target = Math.max(0, Math.min(this.positions.length - 1, index));
      this.scrollToPosition(this.positions[target]);
    }
    move(direction) {
      if (!this.positions?.length) return;
      const offset = this.offset();
      // Move to the next actual snap position; do not loop or clone reviews.
      let target;
      if (direction > 0) {
        target = this.positions.findIndex(position => position > offset + 3);
        if (target < 0) target = this.positions.length - 1;
      } else {
        target = 0;
        this.positions.forEach((position, index) => { if (position < offset - 3) target = index; });
      }
      this.go(target);
    }
    announce() {
      if (!this.status || !this.items?.length || !this.isConnected) return;
      const viewport = this.track.getBoundingClientRect();
      const visible = this.items.map((item, index) => {
        const rect = item.getBoundingClientRect();
        const overlap = Math.min(rect.right, viewport.right) - Math.max(rect.left, viewport.left);
        return overlap > rect.width / 2 ? index + 1 : 0;
      }).filter(Boolean);
      if (!visible.length) return;
      const first = visible[0], last = visible[visible.length - 1];
      this.status.textContent = first === last ? `Review ${first} of ${this.items.length}` : `Reviews ${first} to ${last} of ${this.items.length}`;
    }
  }
  customElements.define(tag, SuttonTrustpilotSlider);
})();


  } catch(e) { console.error(e); }
})();
})();
